var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M27.958 36.227v-3.575H2v3.575a5.528 5.528 0 0 0 5.535 5.535H33.15a5.531 5.531 0 0 1-5.192-5.535Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M33.933 8.555 28.84 4l-5.094 4.555L18.652 4l-5.093 4.555-5.094-4.506v28.6h19.493v3.575a5.532 5.532 0 0 0 5.192 5.535h.343a5.6 5.6 0 0 0 3.918-1.616 5.476 5.476 0 0 0 1.616-3.918V4.049l-5.094 4.506Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeWidth: 3,
    d: "M14 18h20M14 25h20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.baf57e7b152b804c6b4f05924e1838fa.svg";
export { ForwardRef as ReactComponent };